// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.

// external libaries
import 'babel-polyfill'
import Vue from 'vue'
import lodash from 'lodash'
import moment from 'moment-timezone'
import numeral from 'numeral'
import ElementUI from 'element-ui'
import locale from 'element-ui/lib/locale/lang/en'
import Vuebar from 'vuebar'
import VueFloatLabel from 'vue-float-label'
import VuePerfectScrollbar from 'vue-perfect-scrollbar'
import Chart from 'chart.js'
import ChartDataLabels from 'chartjs-plugin-datalabels'
import VueChartkick from 'vue-chartkick'
import InfiniteLoading from 'vue-infinite-loading'
import Notifications from 'vue-notification'
import myUpload from 'vue-image-crop-upload'

import D3Network from 'vue-d3-network'
import * as d3 from 'd3'

import App from './App'
import router from './router'
import store from './store'
import rbac from './mixins/rbacMixin'

Vue.config.productionTip = false
// Apply labels on demand
Chart.plugins.unregister(ChartDataLabels)

Vue.use(lodash)
Vue.use(ElementUI, { locale })
Vue.use(Vuebar)
Vue.use(VueFloatLabel)
Vue.use(VueChartkick, { adapter: Chart })
Vue.use(Notifications, { name: 'alert' })

Vue.component('d3-network', D3Network)
Vue.component('vue-scroll', VuePerfectScrollbar)
Vue.component('v-image-upload', myUpload)
Vue.use(InfiniteLoading)

moment.tz.guess(true) // guess user local timezone
moment.updateLocale('en', {
  relativeTime: {
    future: 'in %s',
    past: '%s ago',
    s: '%d sec',
    ss: '%d sec',
    m: '1 min',
    mm: '%d min',
    h: '1 hr',
    hh: '%d hrs',
    d: '1 day',
    dd: '%d days',
    M: '1 mnth',
    MM: '%d mnths',
    y: '1 yr',
    yy: '%d yrs'
  }
})

Vue.prototype.$numeral = numeral
Vue.prototype.$moment = moment
Vue.prototype.$_ = _
Vue.prototype.$d3 = d3

/*
  Register global mixin
  1. Permissions (rbac) object to be accessible everywhere
      Examples:
      a. vm.$allow('agents', 'read')
      b. v-if="$allow('cyber_attacks', 'write')"
*/
Vue.mixin(rbac)

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js